module.exports = __webpack_public_path__ + "img/0Q3A2626_L_Wood.90b00631.jpg";